import { ReactNode } from 'react';

interface PanelContainerProps {
    children: ReactNode;
}

function PanelContainer({ children }: PanelContainerProps) {
    return <div className="bg-muted flex flex-col items-start rounded-md p-2.5">{children}</div>;
}

export default PanelContainer;
